import type { LucideIcon, LucideProps } from 'lucide-react';

export type { LucideIcon };

export interface IconProps extends Omit<LucideProps, 'size' | 'strokeWidth'> {
  /** Componente da biblioteca Lucide. */
  as: LucideIcon;
  /** Tamanhos alinhados à altura da linha. */
  size?: 16 | 20 | 24;
  /** Rótulo para leitores de tela. Sem ele, o ícone é decorativo. */
  label?: string;
}

/**
 * Ícone do sistema.
 *
 * Padroniza o que o design system fixa: traço 1,75, tamanhos 16/20/24 alinhados
 * à altura da linha, e `currentColor` — a cor vem do contexto, nunca de um HEX.
 *
 * Sem `label`, o ícone recebe `aria-hidden`. É o caso mais comum: o texto ao lado
 * é quem nomeia a ação, e um ícone anunciado junto do rótulo duplica a leitura.
 */
export function Icon({ as: Component, size = 20, label, ...rest }: IconProps) {
  return (
    <Component
      size={size}
      strokeWidth={1.75}
      color="currentColor"
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
      {...rest}
    />
  );
}
